import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPropFilter } from "../../app/slices/PropLibrarySlice";
import PiBrowseDialog from "../../components/PiBrowseDialog";
import PropLibraryBody from "./PropLibraryBody";

interface PropLibraryProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}

export default function PropLibrary(props: PropLibraryProps) {
  const { isOpen, onClose, title } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isOpen) dispatch(setPropFilter(""));
  }, [isOpen, dispatch]);

  return (
    <PiBrowseDialog
      open={isOpen}
      onClose={onClose}
      title={title}
      body={<PropLibraryBody onClose={onClose} />}
    />
  );
}
